import { render, staticRenderFns } from "./ListItemDoctorSpeciality.vue?vue&type=template&id=553081ab&"
import script from "./ListItemDoctorSpeciality.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemDoctorSpeciality.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553081ab')) {
      api.createRecord('553081ab', component.options)
    } else {
      api.reload('553081ab', component.options)
    }
    module.hot.accept("./ListItemDoctorSpeciality.vue?vue&type=template&id=553081ab&", function () {
      api.rerender('553081ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemDoctorSpeciality/ListItemDoctorSpeciality.vue"
export default component.exports